import dubai from "../src/assets/dubai-3-2103072_1280.jpg";
import russia from "../src/assets/russia.jpg";
import uk from "../src/assets/uk.jpg";
import europe from "../src/assets/europe.jpg";
import himachal from "../src/assets/himachal.jpg";
import Kerela from "../src/assets/kerela.jpg";
import goa from "../src/assets/Goa.jpg";
import kashmir from "../src/assets/kashmir.jpg";

const Ddata = [
    {
        img:dubai,
        place:"Dubai"
    },
    {
        img:russia,
        place:"Russia"
    },
    {
        img:uk,
        place:"United Kingdom"
    },
    {
        img:europe,
        place:"Europe"
    },
    {
        img:himachal,
        place:"Himachal Pradesh"
    },
    {
        img:Kerela,
        place:"Kerela"
    },
    {
        img:goa,
        place:"Goa"
    },
    {
        img:kashmir,
        place:"Kashmir"
    }
]

export default Ddata;